export const relayControllerFirmwareVersionSelector = state => state.entities.relayControllerFirmwareVersions;
